import React from 'react'
import PropTypes from 'prop-types'
import {BrowserRouter as Router} from 'react-router-dom'
import {ThemeProvider, createTheme} from '@material-ui/core/styles';

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore' // make sure you add this for firestore
import {ReactReduxFirebaseProvider} from 'react-redux-firebase'
import {createFirestoreInstance} from 'redux-firestore'
import {Provider} from 'react-redux'
import ThemeSettings from 'theme/theme'
import {firebase as fbConfig, reduxFirebase as rfConfig} from 'config'
import Page from '../../components/Page'

import { createBrowserHistory } from 'history';

import 'react-lazy-load-image-component/src/effects/blur.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';

import 'scss/react-images.scss';
import 'scss/slick-slider.scss';


const browserHistory = createBrowserHistory();


const theme = createTheme(ThemeSettings)

// Initialize Firebase instance
firebase.initializeApp(fbConfig)

function App({routes, store}) {
    return (

        <Page>
            <ThemeProvider theme={theme}>
                <Provider store={store}>
                    <ReactReduxFirebaseProvider
                        firebase={firebase}
                        config={rfConfig}
                        dispatch={store.dispatch}
                        createFirestoreInstance={createFirestoreInstance}>
                        <Router>{routes}</Router>
                    </ReactReduxFirebaseProvider>
                </Provider>
            </ThemeProvider>
        </Page>
    )
}

App.propTypes = {
    routes: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
}

export default App
